import { render, staticRenderFns } from "./AdminSourcesTableWrapper.vue?vue&type=template&id=7bb6788e"
import script from "./AdminSourcesTableWrapper.vue?vue&type=script&lang=js"
export * from "./AdminSourcesTableWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports